module.exports = __webpack_public_path__ + "files/5098d5747e96a00446ea2a4a02b49dfd.png";